//Ajax load more
$('.loadmore-consultations').click(function() {
  $(this).text('Loading...')
  var data = {
    action: 'loadmore_consultations',
    query: true_posts, //eslint-disable-line
    page: current_page, //eslint-disable-line
  }
  $.ajax({
    url: ajaxurl, //eslint-disable-line
    data: data,
    type: 'POST',
    success: function(data) {
      if (data) {
        $('.loadmore-consultations')
          .text('Load more')
          .before(data)
        current_page++ //eslint-disable-line
        if (current_page == max_pages) $('.loadmore-consultations').remove() //eslint-disable-line
      } else {
        $('.loadmore-consultations').remove()
      }
    },
  })
})
